/**
 * Vocabulário canônico dos entregáveis do FlowFoundation.
 *
 * As listas de conceito, como-funciona e FAQ têm propósitos e granularidades
 * diferentes — mas quando citam o mesmo entregável precisam usar a mesma
 * redação. Os termos que se repetem entre seções moram aqui para não
 * divergirem na próxima edição.
 */
export const entregavelTermos = {
	discovery: "Discovery consolidado",
	arquitetura: "Arquitetura recomendada",
	roadmap: "Roadmap priorizado",
	estimativa: "Estimativa de prazo e investimento",
} as const;
